import React from 'react';
import "styles/components/menu/company/VisionTab.scss";
import vision1 from 'assets/images/company/vision1.png';
import vision2 from 'assets/images/company/vision2.png';
import vision3 from 'assets/images/company/vision3.png';
import styled from 'styled-components';

const Img = styled.div`
    width: 9.1rem;
    height: 9.2rem;
    background : url(${props => props.src}) center left / cover no-repeat;
    filter: invert(16%) sepia(61%) saturate(1872%) hue-rotate(217deg) brightness(101%) contrast(97%);
`;

const VisionTab = () => {
    return (
        <section className='VisionTab'>
            <div className="VisionTab-wrapper">
                <div className="title">
                    최고 수준의 IT서비스로 <br className='lineBreak' /><span className="fw_bold">고객 비즈니스 성공의 </span>
                    <br className='lineBreak pc' />
                    <span className="fw_bold">핵심파트너</span>로 <br className='lineBreak' />성장해나가겠습니다
                </div>
                <div className="cards">
                    <div className="card">
                        <Img className="card-vision" src={vision1} />
                        <div className="card-title">신의</div>
                        <div className="card-text">
                            고객과의 약속을 지킴으로<br className='lineBreak' />
                            고객의 가치 증대에 기여하는 기업
                        </div>
                    </div>
                    <div className="card">
                        <Img className="card-vision" src={vision2} />
                        <div className="card-title">기술경쟁력</div>
                        <div className="card-text">
                            스마트하고 창의적인 기술로<br className='lineBreak' />
                            IT 분야 소프트웨어 및 제품 개발<br className='lineBreak' />
                            기술 경쟁력이 있는 기업</div>
                    </div>
                    <div className="card">
                        <Img className="card-vision" src={vision3} />
                        <div className="card-title">행복한 공동체</div>
                        <div className="card-text">
                            일을 통한 자아실현으로<br className='lineBreak' />
                            직원의 행복을 추구하는 기업
                        </div>
                    </div>
                </div>
            </div>
        </section >
    );
};

export default VisionTab;